import {GameStateEnums} from '../../../../../shared/GameEnums'
import {UIGameBaseDiceController} from '../../../../shared/scripts/ui_game/ui_game_dice/UIGameBaseDiceController'
import {UIGameBaseDiceView} from '../../../../shared/scripts/ui_game/ui_game_dice/UIGameBaseDiceView'
import {UIGameDiceView} from '../../../../shared/scripts/ui_game/ui_game_dice/UIGameDiceView'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'

export class UIMGameBaseDiceController extends UIGameBaseDiceController {
    protected initializeOpponentDiceViews() {
        this.opponentDiceViews = []

        const playersController = this.uiGameManager.playersController
        if(!playersController) return

        const playerViewWidth = playersController.playerInformationViews[0].width
        const playerViewHeight = playersController.playerInformationViews[0].height

        const opponentDiceSize = playerViewHeight / 2.25
        const spaceBetweenDice = this.uiGameManager.canvasController.margin
        const baseDiceY = playerViewHeight * 0.1
        let index = 1
        for(const playerView of playersController.playerInformationViews) {
            if(playerView.player.color == this.uiGameManager.gameController.myColor) continue
            const isPlayerOnLeft = UIUtilsEjsVariables.isUserOnTabletApp ? false : (playerView.position.x < this.uiGameManager.canvasController.appW / 2)
            const baseDiceX = isPlayerOnLeft ? playerViewWidth : -opponentDiceSize
            const opponentDice = new UIGameBaseDiceView(this.uiGameManager, this.isRedDiceActive, baseDiceX, baseDiceY, playerView, opponentDiceSize, spaceBetweenDice, false, false)
            opponentDice.tintPassive()
            opponentDice.hide()
            this.opponentDiceViews.push(opponentDice)
            index += 1
        }
    }

    protected getOpponentDiceViewToDisplay(currentTurnPlayerIndex: number, opponentCount: number): UIGameDiceView {
        return this.opponentDiceViews[currentTurnPlayerIndex]
    }
}
